<!-- review -->
<div class="row mt-5">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center border-bottom mb-4 pb-2">
      <h5 class="aa-heading-title fw-bold  mb-0">
        <i class="bi bi-person-badge me-2"></i>{{'Librarian Review' | translate}}
      </h5>
      <a routerLink="../admin/addreview/{{ bibid }}"
        class="btn btn-primary btn-sm rounded-pill px-3 shadow-sm hover-elevate-up d-flex align-items-center gap-2"
        *ngIf="addStatus">
        <i class="bi bi-plus-lg"></i> {{ "Add review" | translate }}
      </a>
    </div>

    <ngx-spinner bdOpacity="0.9" bdColor="" size="default" color="#581f87" type="ball-pulse-sync" [fullScreen]="false">
    </ngx-spinner>

    <div *ngIf="reviewData.length > 0; else noReviews">
      <div class="d-flex flex-column gap-3">
        <div class="card border-0 shadow-sm rounded-4 p-3 bg-white" *ngFor="let item of reviewData">
          <div class="card-body p-0">
            <div class="d-flex gap-3">
              <div class="flex-shrink-0">
                <div
                  class="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center"
                  style="width: 40px; height: 40px;">
                  <i class="bi bi-chat-quote fs-5"></i>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="mb-2 text-dark review-detail-content" [innerHTML]="item.REVIEWDETAIL"></div>
                <div
                  class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 pt-3 border-top border-light-subtle">
                  <div class="text-secondary small d-flex align-items-center gap-2">
                    <i class="bi bi-person-circle"></i>
                    <span class="fw-semibold">{{ item.REVIEWBy }}</span>
                    <span class="text-body-tertiary">•</span>
                    <span>{{ item.REVIEWDATE }}</span>
                  </div>

                  <div class="d-flex gap-2" *ngIf="editStatus">
                    <a routerLink="../admin/editreview/{{ item.REVIEWID }}"
                      class="btn btn-outline-primary btn-sm rounded-pill px-3 d-flex align-items-center gap-2 hover-elevate-up text-decoration-none">
                      <i class="bi bi-pencil-square"></i> {{ 'Edit' | translate }}
                    </a>
                    <button type="button" (click)="deleteReview(item.REVIEWID)"
                      class="btn btn-outline-danger btn-sm rounded-pill px-3 d-flex align-items-center gap-2 hover-elevate-up">
                      <i class="bi bi-trash"></i> {{ 'Delete' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noReviews>
      <div class="text-center py-4 bg-light rounded-4 border border-dashed">
        <i class="bi bi-chat-square-text text-secondary opacity-25 fs-1 mb-2 d-block"></i>
        <p class="text-muted mb-0">{{ 'NoLibrarianReviewsYet' | translate }}</p>
      </div>
    </ng-template>

  </div>
</div>